
//Calcula el Digito de Verificacion -DV de la Clinica
export const CalcularDigitoVerificacion = (nit) => {
    var contador = 0;
    var vector = new Array(3, 7, 13, 17, 19, 23, 29, 37, 41, 43, 47, 53, 59, 67, 71);
    var acumulador = 0;
    var residuo = 0;
    for (contador = 0; contador < nit.length; contador++) {
        var temp = nit[(nit.length - 1) - contador];
        acumulador = acumulador + (temp * vector[contador]);
    }

    residuo = acumulador % 11;
    return residuo > 1 ? 11 - residuo : residuo;
}

//Responsabilidad Tributaria del Emisor o del Adquiriente de la Factura
export const VerificarResponsabilidadTributaria = (responsabilidad) => {
    switch (responsabilidad) {
        case 1:
            return "O-13" //GRAN CONTRIBUYENTE
        case 2:
            return "O-15" //AUTORRETENEDOR
        case 3:
            return "O-23" //AGENTE DE RETENCIÓN IVA
        case 4:
            return "O-47" //RÉGIMEN SIMPLE DE TRIBUTACIÓN
        default:
            return "R-99-PN" //NO RESPONSABLE (NO RESPONSABLE DE IVA)
    }
}

export const VerificacionTipoDocumentoAdquiriente = (tip_documento) => {
    switch (tip_documento) {
        case "NIT":
            return "31" //NIT de la Empresa
        case "RC":
            return "11" //Registro Civil de Nacimiento
        case "TI":
            return "12" //Tarjeta de Identidad
        case "CC":
            return "13" //Cedula de Ciudania Colombiana
        case "CE":
            return "22" //Cedula de Extranjeria
        case "PA":
            return "41" //Pasaporte
        default:
            return "91" //Adquiriente NIUP
    }
}

//Solo para Facturas Comerciales, calcula el IVA de los ITEMS
export const calcularIVACompleto = (items) => {
    let acc_valor_iva = items.reduce((prev, current) => {
        let acc = prev + current.valor_iva;
        return acc;
    }, 0);
    return acc_valor_iva;
}

//Calcular el Valor de la Base Imponible de los items
export const calcularBaseImponible = (items) => {
    let acc_base_imponible = items.reduce((prev, current) => {
        let acc = prev + current.costo;
        return acc;
    }, 0);
    return acc_base_imponible;
}

export const calcularValorRealTotalItems = (items) => {
    let acc_base_imponible = items.reduce((prev, current) => {
        let acc = prev + (parseInt(current.costo) * parseInt(current.cantidad)) + ((parseInt(current.costo) * parseInt(current.cantidad) * 0.19));
        return acc;
    }, 0);
    return acc_base_imponible;
}

export const verificarMedioPagoComercial = (medioPago, tipoNegociacion) => {
    switch (medioPago.toUpperCase()) {
        case "EFECTIVO":
            return 10;
        case "TARJETA":
            if (tipoNegociacion.toUpperCase() == "CREDITO") {
                return 30;
            }
            else {
                return 31;
            }
        default:
            return 10;
    }
}